import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tracker-info-drawer__header mb-3" }
const _hoisted_2 = { class: "px-5" }
const _hoisted_3 = { class: "team-info__info-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Имя", -1)
const _hoisted_5 = { class: "team-info__info-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Почта", -1)
const _hoisted_7 = { class: "team-info__info-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Telegram", -1)
const _hoisted_9 = { class: "team-info__info-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Супервизор", -1)
const _hoisted_11 = { class: "team-info__info-item py-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"align-self":"flex-start"}
}, "Био", -1)
const _hoisted_13 = { style: {"white-space":"pre-wrap"} }

import { useUiStore } from '@/stores/ui';
import { computed, ref } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import VUserInfo from '@/components/VUserInfo.vue'
import AddUserDialog from './dialogs/AddUserDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheTrackerDrawer',
  setup(__props) {

const uiStore = useUiStore()
const drawer = computed<boolean>({
  get() {
    return !!uiStore.tracker
  },
  set(value) {
    if (!value) uiStore.tracker = null
  }
})

const tabs = ref("info")

const dialogStore = useDialogStore()
const edit = () => {
  dialogStore.open(AddUserDialog, { user: uiStore.tracker })
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _unref(drawer),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : null)),
    temporary: "",
    location: "right",
    class: "team-info-drawer",
    width: "500"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(VUserInfo, {
          "user-id": _unref(uiStore).tracker?.id,
          size: 36
        }, null, 8, ["user-id"]),
        _createVNode(_component_v_btn, {
          icon: "mdi-pencil",
          variant: "flat",
          class: "ml-auto",
          onClick: edit
        }),
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          variant: "flat",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).tracker = null))
        })
      ]),
      _createVNode(_component_v_tabs, {
        modelValue: tabs.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tabs).value = $event)),
        color: "primary",
        class: "px-5 mb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "info" }, {
            default: _withCtx(() => [
              _createTextVNode("Общая информация")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "tracker-reports" }, {
            default: _withCtx(() => [
              _createTextVNode("Oтчеты трекера")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: tabs.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tabs).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "info" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_unref(uiStore).tracker?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref(uiStore).tracker?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_unref(uiStore).tracker?.telegram || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_v_checkbox, {
                    "model-value": _unref(uiStore).tracker?.isSupervisor,
                    class: "ml-n3",
                    disabled: "",
                    "hide-details": ""
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(uiStore).tracker?.bio || "-"), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tracker-reports" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})